import { PublicKey } from '@solana/web3.js'
import Decimal from 'decimal.js'
import { u128ToDecimal } from '../utils/HedgeConstants'


export default class ReferralAccount {
  public referrer: PublicKey
  public setupCut: Decimal
  public referredUserDiscount: Decimal
  public stabilityCut: Decimal
  public psmCut: Decimal
  public ushAccumulator: Decimal
  public hdgAccumulator: Decimal
  public ushClaimed: number
  public referralId: Decimal

  constructor(config: any) {
    this.referrer = config.referrer
    this.setupCut = u128ToDecimal(config.setupCut)
    this.referredUserDiscount = u128ToDecimal(config.referredUserDiscount)
    this.stabilityCut = u128ToDecimal(config.stabilityCut)
    this.psmCut = u128ToDecimal(config.psmCut)
    this.ushAccumulator = new Decimal(config.ushAccumulator.toString())
    this.hdgAccumulator = new Decimal(config.hdgAccumulator.toString())
    this.ushClaimed = config.ushClaimed.toNumber()
    // Has to be stored as a decimal as the numbers are very large 64 bit numbers
    this.referralId = new Decimal(config.referralId.toString())
  }
}
